// eslint-disable-next-line import/prefer-default-export
export const TRIGGER_KEYS = {
  9: 'tab',
  13: 'enter',
  32: 'space',
};
